import { put, call, take, fork } from 'redux-saga/effects'
import {
  getCustomBadgesService,
  createCustomBadgeService,
  updateCustomBadgeService,
  deleteCustomBadgeService,
} from '../../api/badge'
import {
  GET_CUSTOM_BADGES,
  CREATE_CUSTOM_BADGE,
  UPDATE_CUSTOM_BADGE,
  DELETE_CUSTOM_BADGE,
} from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

function* getCustomBadgesFlow(payload) {
  const { callback } = payload
  try {
    const response = yield call(getCustomBadgesService)
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

function* createCustomBadgeFlow(payload) {
  const { data, callback } = payload
  try {
    const response = yield call(createCustomBadgeService, data)
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

function* updateCustomBadgeFlow(payload) {
  const { id, data, callback } = payload
  try {
    yield call(updateCustomBadgeService, id, data)
    yield put(operationSuccess())
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

function* deleteCustomBadgeFlow(payload) {
  const { id, callback } = payload
  try {
    yield call(deleteCustomBadgeService, id)
    yield put(operationSuccess())
    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

export function* getCustomBadgesWatcher() {
  while (true) {
    const action = yield take(GET_CUSTOM_BADGES)
    yield fork(generalSaga, getCustomBadgesFlow, action.payload)
  }
}

export function* createCustomBadgeWatcher() {
  while (true) {
    const action = yield take(CREATE_CUSTOM_BADGE)
    yield fork(generalSaga, createCustomBadgeFlow, action.payload)
  }
}

export function* updateCustomBadgeWatcher() {
  while (true) {
    const action = yield take(UPDATE_CUSTOM_BADGE)
    yield fork(generalSaga, updateCustomBadgeFlow, action.payload)
  }
}

export function* deleteCustomBadgeWatcher() {
  while (true) {
    const action = yield take(DELETE_CUSTOM_BADGE)
    yield fork(generalSaga, deleteCustomBadgeFlow, action.payload)
  }
}
